import React, { useState } from 'react';
import styles from './styles.module.scss';
import { SearchFilter } from '../SearchFilter';
import { SuggestedApp } from '../../models/app';
import { NavigationHeader } from '../NavigationHeader';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { useAppCollections } from '../../contexts/providers/collection';
import { useFetchAppCategoriesQuery, useFetchSuggestedAppsQuery } from '../../redux/api/appMarket-api-slice';
import { RenderSearchItem } from '../SearchFilter/AppSearchAutoCompleteItem';
import { getListFromEntityState } from '../../utils/helpers';
import { AppMarketPageIdentifier } from '../../AppRoutes';
import { generateRoute } from '../../utils/location';
import { useAppContext } from '../../hooks/useAppContext';
import { BackgroundShimmer } from 'components/Shimmer';

export const Header = (): JSX.Element => {
  const { t } = useTranslation();
  const [searchString, setSearchString] = useState<string>('');
  const { collections, isLoading: collectionsLoading } = useAppCollections();
  const { data: categories, isLoading: categoriesLoading } = useFetchAppCategoriesQuery('');
  const merchantId = useAppContext()?.id || '';
  let { data: suggestedApps, isLoading: isLoadingSuggestedApps, isFetching: isFetchingSuggestedApps } = useFetchSuggestedAppsQuery({ q: searchString, merchantId: merchantId }, {
    skip: !searchString,
    selectFromResult: ({ data, isLoading, isFetching }) => {
      let results: Maybe<SuggestedApp[]> = [];
      if (data && searchString){
        results = getListFromEntityState<SuggestedApp>(data.suggestedApps);
      }
      return {
        data: results,
        isLoading,
        isFetching
      }
    }
  });
  let history = useHistory();

  const changeStateToSearchedApps = (value: string) => {
    history.push(generateRoute(AppMarketPageIdentifier.SearchedApps, encodeURIComponent(value)));
  }

  const handleOnchange = (q: string) => {
   setSearchString(q);
  };

  const selectApp = ({ app } : SuggestedApp) => {
    if (!app) return;
    history.push(generateRoute(AppMarketPageIdentifier.AppDetails, [`${app.id}`]));
  };

  if (collectionsLoading || categoriesLoading) return <BackgroundShimmer smallShimmer={true} />;

  return (
    <div className={styles.headerContainer}>
      <div className={styles.searchFilter}>
        <SearchFilter<SuggestedApp>
          onChangeCallBack={handleOnchange}
          onSelect={selectApp}
          placeholder={t('app_search.app_search_placeholder')}
          renderItem={RenderSearchItem}
          handleEnterKeyPress={changeStateToSearchedApps}
          results={suggestedApps}
          isLoading={isLoadingSuggestedApps || isFetchingSuggestedApps}
          popperRootClass={styles.autoCompletePopperRoot}
          optionClass={styles.autoCompleteOption}
        />
      </div>
      <NavigationHeader categories={categories} collections={collections} isLoading={categoriesLoading || collectionsLoading} />
    </div>
  );
};
